import { linkClasses } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export const CUSTOM_ATTRIBUTE_FONT_WEIGHT = 'data-0';

export default function MUILink() /*: Components['MuiLink']*/ {
  return {
    defaultProps: {
      underline: 'none',
      color: 'primary',
    },
    styleOverrides: {
      root: {
        [`&.${linkClasses.focusVisible}`]: {
          textDecoration: 'underline',
        },
      },
    },
    variants: [
      ...[100, 200, 300, 400, 500, 600, 700, 800, 900].map((fontWeight) => ({
        props: { [CUSTOM_ATTRIBUTE_FONT_WEIGHT]: fontWeight },
        style: {
          fontWeight,
        },
      })),
    ],
  };
}
